import { Market } from './core/index';

/**
 * 直接调用客户端底层接口
 * @param name 接口名称
 * @param params 接口参数
 */
export const call = async (name: string, params?: any) => Market.__asyncCallApi(name, params);

export const invoke = call;

/**
 * 直接通过 scheme 伪协议调用客户端接口
 * @param url scheme 伪协议，如 jsbridge://xxx
 */
export function callWithScheme(url: string): Promise<any> {
  throw new Error('Method not implemented');
}
